import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import './LoginPage.css';
import { AuthContext } from "../../AuthContext";
import { loginUserAPI, getUserInfo } from "../../apis/login.api";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

function LoginPage(props) {
  const { authData, login, setAuthData, setUserInfo } = useContext(AuthContext);
  const [loginError, setLoginError] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const handleLoginBtnClick = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {      // Get login tokens
      const response = await loginUserAPI(authData);

      // Create a clean version without username/password for storage
      const updatedAuthData = {
        userrole: authData.userrole,
        access_token: response?.access_token,
        refresh_token: response?.refresh_token,
        token_type: response?.token_type
        // username and password are intentionally omitted for security
      };

      setAuthData(updatedAuthData);
      sessionStorage.setItem('loginData', JSON.stringify(updatedAuthData));

      // Fetch user info immediately after login
      try {
        const userInfoData = {
          access_token: response?.access_token,
          token_type: response?.token_type,
          organisationId: 1,
          projectId: 1
        };
        const userInfoResult = await getUserInfo(userInfoData);

        if (userInfoResult) {
          // Update the userInfo in both session storage and context
          sessionStorage.setItem('userInfo', JSON.stringify(userInfoResult));
          setUserInfo(userInfoResult); // Add this line to update AuthContext
        }
      } catch (userInfoError) {
        console.error("Error fetching user info:", userInfoError);
      }

      setLoginError(false);
      navigate("/agents");
    } catch (error) {
      setLoginError(true);
      // navigate("/");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setLoginError(false);
    }, 4000)
  }, [loginError])

  return (
    <>
      <Backdrop
        sx={{ color: "#ffffff", zIndex: (theme) => theme.zIndex.drawer + 1, height: '125vh !important' }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div className="loginPage">
        <main className="Container">
          {loginError && <div className="loginError"><strong>Please enter a valid username and password.</strong></div>}
          <form onSubmit={handleLoginBtnClick}>
            <div className="containerHeader">
              <div className="loginText" style={{ textAlign: 'left' }}>Login</div>
              <div className="loginSubText" style={{ textAlign: 'left' }}>
                Welcome, please enter your details
              </div>
            </div>
            <div className="containerBody">
              <div className="mb-4" style={{ textAlign: 'left' }}>
                <label htmlFor="username" className="loginFormlabel">Username</label>
                <input
                  id="username"
                  type="text"
                  className="form-control mt-2"
                  name="username"
                  value={authData?.username}
                  placeholder="Enter Username"
                  required
                  onChange={(e) => login(e)}
                />
              </div>
              <div className="mb-4" style={{ textAlign: 'left' }}>
                <label htmlFor="password" className="loginFormlabel">Password</label>
                <input
                  id="password"
                  type="password"
                  className="form-control mt-2"
                  name="password"
                  value={authData?.password}
                  placeholder="Enter Password"
                  required
                  onChange={(e) => login(e)}
                />
              </div>
            </div>
            <div className="containerBOdyExtended">
              <div>
                <input
                  id="rememberMe"
                  className="default-checkbox"
                  type="checkbox"
                  checked={rememberMe}
                  onChange={() => setRememberMe(!rememberMe)}
                />
                <label htmlFor="rememberMe" className="rememberMeLabel">
                  <span className="custom-checkbox"></span> Remember Me
                </label>
              </div>
              <button
                className="forgetPassword"
                style={{
                  border: 'none',
                  background: 'none',
                  padding: 0, cursor: 'pointer'
                }}
              >
                Forget Password?
              </button>
            </div>
            <div className="containerFooter" style={{ textAlign: 'left' }}>
              <button
                type="submit"
                className="loginButton"
                style={{ textTransform: 'capitalize' }}
              >
                <span className="loginButtonText">Log In</span>
              </button>
            </div>
          </form>
        </main>
      </div>
    </>
  );
}
export default LoginPage;